module.exports = __webpack_public_path__ + "img/icon3.ef916377.png";